import React, { useState } from 'react';
import ButtonEndStepsInformativo from './ButtonEndStepsInformativo';
import ButtonBackInformativo from './ButtonBackInformativo';
import ButtonNextInformativo from './ButtonNextInformativo';
import ButtonInformativoStepsIndicators from './ButtonInformativoStepsIndicators';
import i18n from '../../../config/I18n';
import icnVolverInicio from '../../assets/svg/icnVolverInicio.svg';
import CedulaMano from './assets/img/CedulaMano.svg';
import LiquidacionSueldo from './assets/img/liqSueldo.svg';
import LiquidacionAfp from './assets/img/afp_iilustracion.svg';
import reloj from './assets/img/reloj.svg';
import campana from './assets/img/campana.svg';
import persona from './assets/img/persona.svg';
import alarma from './assets/img/alarma.svg';
import ButtonBase from '../button/ButtonBase';
import IcnCerrarModalfrom from '../../assets/svg/icnCerrarModal.svg'
import './ModalInformativo.css';

function ModalInformativo({ visible, ocultar }) {
  const [step, setStep] = useState("one");
  const [classOne, setClassOne] = useState("circleStepSelected");
  const [classTwo, setClassTwo] = useState("circleStepUndone");
  const [classThree, setClassThree] = useState("circleStepUndone");
  const [classFour, setClassFour] = useState("circleStepUndone");
  const [titleModal, setTitle] = useState(i18n.t('modalInformativo.titulo'));

  const objectList = [
    { "titulo": i18n.t('modalInformativo.list_titulo_a'), "subtitulo": i18n.t('modalInformativo.list_detalle_a'), "img": reloj },
    { "titulo": i18n.t('modalInformativo.list_titulo_b'), "subtitulo": i18n.t('modalInformativo.list_detalle_b'), "img": campana },
    { "titulo": i18n.t('modalInformativo.list_titulo_c'), "subtitulo": i18n.t('modalInformativo.list_detalle_c'), "img": persona },
    { "titulo": i18n.t('modalInformativo.list_titulo_d'), "subtitulo": i18n.t('modalInformativo.list_detalle_d'), "img": alarma }
  ]

  const list = objectList.map((item) => (
    <div key={item.titulo} className="row">
      <div className="col-2 marginIcon"><img className="iconsMin" src={item.img} alt={item.titulo} /></div>
      <div className="col-10 pad5">
        <h4 className="mbottom0 mtop10"><strong>{item.titulo}</strong></h4>
        <small>{item.subtitulo}</small>
      </div>
    </div>
  ));

  const stepOne = (
    <div className="txtAlignC">
      <div className="row">
        <div className="col-sm-12">
          <div className="modalInformativoContentMargin">
            <img className="iconsMax" src={CedulaMano} alt="cedula" />
            <br />
            <small><strong>{i18n.t('modalInformativo.one_nota_titulo_cedula')}</strong></small>
            <br />
            <small>{i18n.t('modalInformativo.one_nota_detalle_cedula')}</small>
          </div>
        </div>
      </div>
    </div>
  );

  const stepTwo = (
    <div className="txtAlignC">
      <div className="row">
        <div className="col-sm-12">
          <div className="modalInformativoContentMargin">
            <img className="iconsMax" src={LiquidacionSueldo} alt="liquidacion" />
            <br />
            <small><strong>{i18n.t('modalInformativo.one_nota_titulo_liquidacion')}</strong></small>
            <br />
            <small>{i18n.t('modalInformativo.one_nota_detalle_liquidacion')}</small>
            <br />
            <small>{i18n.t('modalInformativo.one_archivos')}</small>
          </div>
        </div>
      </div>
    </div>
  );

  const stepThree = (
    <div className="txtAlignC">
      <div className="row">
        <div className="col-sm-12">
          <div className="modalInformativoContentMargin">
            <img className="iconsMax" src={LiquidacionAfp} alt="liquidacion" />
            <br />
            <small><strong>{i18n.t('modalInformativo.one_nota_titulo_afp')}</strong></small>
            <br />
            <small>{i18n.t('modalInformativo.one_nota_detalle_afp')}</small>
            <br />
            <small>{i18n.t('modalInformativo.one_archivos')}</small>
          </div>
        </div>
      </div>
    </div>
  );

  const stepFour = (
    <div className="txtAlignL modalInformativoContentStepThree">
      {list}
    </div>
  );
  

  return (
    <>
      {visible && (
        <div className="modalInformativo">
          <div className="modalInformativoContainer">
            <div className="modal">
              <div className="row">
                <div className="col">
                  <div className="line-bottom">
                    <h4 className="mbottom0 mtop10 marginStart"><strong>{titleModal}</strong></h4>
                  </div>
                  <ButtonBase
                    icons={IcnCerrarModalfrom}
                    callClick={() => { ocultar(); setStep("one") }}
                    css="salir"
                  />
                </div>
              </div>
              {step === "one" ? stepOne : ""}
              {step === "two" ? stepTwo : ""}
              {step === "three" ? stepThree : ""}
              {step === "four" ? stepFour : ""}
              <hr />
              <div className="row mtop10 mbottom10 pad5">
                <div className="col-lg-4 col-md-4 col-sm-12 txtAlignL">
                  <ButtonInformativoStepsIndicators
                    classNameStepOne={classOne}
                    classNameStepTwo={classTwo}
                    classNameStepThree={classThree}
                    classNameStepFour={classFour}
                  />
                </div>
                
                <div className="col-6 col-sm-6 col-md-4 order-md-first txtAlignL">
                  {step === "one" ? "" : (
                    <ButtonBackInformativo
                      icons={icnVolverInicio}
                      callClick={() => {
                        if (step === "two") {
                          setStep("one")
                          setTitle(i18n.t('modalInformativo.titulo'))
                          setClassOne("circleStepSelected")
                          setClassTwo("circleStepUndone")
                          setClassThree("circleStepUndone")
                          setClassFour("circleStepUndone")
                        } else if (step === "three") {
                          setStep("two")
                          setTitle(i18n.t('modalInformativo.titulo'))
                          setClassOne("circleStepDone")
                          setClassTwo("circleStepSelected")
                          setClassThree("circleStepUndone")
                          setClassFour("circleStepUndone")
                        }
                        else if (step === "four") {
                          setStep("three")
                          setTitle(i18n.t('modalInformativo.titulo'))
                          setClassOne("circleStepDone")
                          setClassTwo("circleStepDone")
                          setClassThree("circleStepSelected")
                          setClassFour("circleStepUndone")
                        }
                      }}
                      css="botonCancelarInformativo txtAlignL mbottom10 margin10"
                      buttonName={i18n.t('modalInformativo.botonAnterior')}
                      etiqueta={i18n.t('modalInformativo.botonAnterior')}
                    />
                  )}
                </div>
                <div className="col-6 col-sm-6 col-md-4 txtAlignR">
                  {step === "one" || step === "two" || step === "three" ? (
                    <ButtonNextInformativo
                      icons={icnVolverInicio}
                      callClick={() => {
                        if (step === "one") {
                          setStep("two")
                          setTitle(i18n.t('modalInformativo.titulo'))
                          setClassOne("circleStepDone")
                          setClassTwo("circleStepSelected")
                          setClassThree("circleStepUndone")
                          setClassFour("circleStepUndone")
                        } else if (step === "two") {
                          setStep("three")
                          setTitle(i18n.t('modalInformativo.titulo'))
                          setClassOne("circleStepDone")
                          setClassTwo("circleStepDone")
                          setClassThree("circleStepSelected")
                          setClassFour("circleStepUndone")
                        }
                        else if (step === "three") {
                          setStep("four")
                          setTitle(i18n.t('modalInformativo.thow_titulo'))
                          setClassOne("circleStepDone")
                          setClassTwo("circleStepDone")
                          setClassThree("circleStepDone")
                          setClassFour("circleStepSelected")
                        }
                      }}
                      css="botonNextInformativo txtAlignR mbottom10 margin10"
                      buttonName={i18n.t('modalInformativo.botonSiguiente')}
                      etiqueta={i18n.t('modalInformativo.botonSiguiente')}
                    />
                  ) : (
                    <ButtonEndStepsInformativo
                      callFunction={() => { ocultar(); setStep("one") }}
                      buttonName={i18n.t('modalInformativo.botonEntendido')}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
};

export default ModalInformativo;
